import React from "react";
import { Checkbox, Button } from "antd";

const TelemetryOptionsStep = ({
  telemetrySelection,
  setTelemetrySelection,
  onCancel,
  onConfirm,
}) => {
  const options = [
    { label: "Temperatura", value: "temp" },
    { label: "Humedad", value: "humidity" },
  ];

  const confirmDisabled = telemetrySelection.length === 0;

  return (
    <>
      <h4>Descargar Informe o Mediciones</h4>
      <p>¿Qué telemetrías desea incluir?</p>

      <Checkbox.Group
        className="checkbox-group"
        options={options}
        value={telemetrySelection}
        onChange={setTelemetrySelection}
      />

      <div className="footer-buttons">
        <Button type="default" className="cancel-button" onClick={onCancel}>
          Cancelar
        </Button>
        <Button
          type="default"
          className="download-button"
          onClick={onConfirm}
          disabled={confirmDisabled}
        >
          Descargar
        </Button>
      </div>
    </>
  );
};

export default TelemetryOptionsStep;
